/* wg-resources-menu.js
   Moves the Resources mega-menu contents into the Resources panel.

   The markup itself is a theme section — sections/wg-resources-menu.liquid,
   parked in the Footer group and editable at
   Theme editor > Footer Group > Resources mega-menu. Nothing here is
   hardcoded any more; this file only relocates what that section rendered.

   WHY IT IS MOVED RATHER THAN RENDERED IN PLACE
   sections/header-nav-multi-site.liquid is 250KB, past the size a theme
   file can be written at through the API, so the panel's own blocks cannot
   be edited. Rendering elsewhere and moving is the way in.

   Idempotent: each panel is filled once, guarded by data-wg-built.
*/
(function () {
  var SRC = '[data-wg-resources-source]';
  var cached = null;

  function markup() {
    if (cached !== null) return cached;
    var src = document.querySelector(SRC);
    if (!src) return null;
    var html = src.innerHTML.trim();
    if (!html) return null;
    cached = html;
    src.innerHTML = '';
    return cached;
  }

  function build(panel) {
    if (panel.getAttribute('data-wg-built')) return;

    var html = markup();
    if (!html) return;

    var grid = panel.querySelector('.mm-content__grid') ||
               panel.querySelector('.mm-panel__grid');
    if (!grid) return;

    grid.innerHTML = html;
    grid.classList.add('wg-mmr-grid');
    grid.style.setProperty('--wg-mmr-cols', grid.children.length || 4);
    panel.setAttribute('data-wg-built', '1');
  }

  function run() {
    var panels = document.querySelectorAll('[id^="mmpanel-resources"]');
    for (var i = 0; i < panels.length; i++) build(panels[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // The header can re-render on nav interactions; re-check cheaply.
  document.addEventListener('click', function () { setTimeout(run, 60); }, true);
  // Theme editor: re-run after a section re-renders.
  document.addEventListener('shopify:section:load', function () { cached = null; setTimeout(run, 60); });
})();
